
import getAvatar from "./getAvatar";
import getAllAvatars from "./getAllAvatars";

export default {
    getAvatar,
    getAllAvatars,
}